import { useEffect, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { Sidebar } from "./Sidebar";
import { Topbar } from "./Topbar";

/**
 * Two columns: a 216px rail and everything else.
 *
 * 216 rather than the 240 a console usually takes — the labels are one word
 * and the tables want the width. Below `lg` the rail becomes a drawer,
 * because the queues do get triaged from a phone.
 */
export function AdminShell() {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setDrawerOpen(false);
  }, [location.pathname]);

  return (
    <div className="flex min-h-screen bg-bg">
      <aside className="hidden lg:block w-[236px] shrink-0 bg-brand-pink sticky top-0 h-screen">
        <Sidebar />
      </aside>

      {drawerOpen ? (
        <>
          <button
            type="button"
            aria-label="Close navigation"
            onClick={() => setDrawerOpen(false)}
            className="fixed inset-0 z-40 bg-ink/40 backdrop-blur-[2px] lg:hidden animate-fade"
          />
          <aside className="fixed inset-y-0 left-0 z-50 w-[276px] bg-brand-pink shadow-float lg:hidden animate-rise">
            <Sidebar onNavigate={() => setDrawerOpen(false)} />
          </aside>
        </>
      ) : null}

      <div className="brand-canvas flex min-w-0 flex-1 flex-col overflow-x-hidden">
        <Topbar onOpenNav={() => setDrawerOpen(true)} />
        <main className="relative mx-auto w-full min-w-0 max-w-[1420px] flex-1 px-4 py-6 lg:px-8 lg:py-8">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
